import { Card, CardContent, Grid, Typography } from '@mui/material';
import { ResourceInfoItem, ResourceSummaryInfo } from './ResourceSummaryInfo';
import { ResourceSummaryTabs } from './ResourceSummaryTabs';

type Props = {
  title: string;
  items: ResourceInfoItem[] | null;
  valueTitle: string;
  metadataTitle: string;
  value: object | null;
  metadataValue: object | null;
  loading: boolean;
  enableClipboard?: boolean;
  leftWidth?: 4 | 6 | 8;
};

export const ResourceSummary = (props: Props) => {
  const { title, items, value = null, metadataValue = null, valueTitle, metadataTitle, loading, enableClipboard, leftWidth = 4 } = props;
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item sm={12} md={leftWidth}>
            <Typography variant="h5" component="p" sx={{ pb: 3 }}>
              {title}
            </Typography>
            <ResourceSummaryInfo loading={loading} items={items} />
          </Grid>
          <Grid item sm={12} md={12 - leftWidth}>
            <ResourceSummaryTabs
              loading={loading}
              value={value}
              metadata={metadataValue}
              valueTitle={valueTitle}
              metadataTitle={metadataTitle}
              enableClipboard={enableClipboard}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
